<div class="header">
  <h1 mat-dialog-title>Naturfond Gl. Rye</h1>
  <span>Version {{ environment.myVersion }}</span>
</div>

<div mat-dialog-content>
  Bygget med
  <a target="_new" href="http://angular.io">Angular</a> {{ environment.ngVersion }} og
  <a target="_new" href="http://material.angular.io">Angular Material</a> {{ environment.matVersion }}. Programmeret i
  <a target="_new" href="http://typescriptlang.org">TypeScript</a> {{ environment.tsVersion }}.
</div>

<div mat-dialog-actions>
  <button mat-raised-button cdkFocusInitial type="submit" color="primary" (click)="ok()">OK</button>
</div>
